export enum MeasureUnitType {
  "" = "",
  mg = "mg",
  g = "g",
  kg = "kg",
  ml = "ml",
  lt = "lt",
  dz = "dz",
  un = "un",
  co = "co",
  qb = "qb",
}

export type TMeasureUnitType = keyof typeof MeasureUnitType;

type MeasureInfoItem = {
  source: MeasureUnitType;
  factor: number;
  base: MeasureUnitType;
};
export const MeasureInfo: MeasureInfoItem[] = [
  { source: MeasureUnitType.kg, factor: 1_000_000, base: MeasureUnitType.mg },
  { source: MeasureUnitType.g, factor: 1_000, base: MeasureUnitType.mg },
  { source: MeasureUnitType.mg, factor: 1, base: MeasureUnitType.mg },
  { source: MeasureUnitType.lt, factor: 1_000, base: MeasureUnitType.ml },
  { source: MeasureUnitType.ml, factor: 1, base: MeasureUnitType.ml },
  { source: MeasureUnitType.dz, factor: 12, base: MeasureUnitType.dz },
  { source: MeasureUnitType.un, factor: 1, base: MeasureUnitType.un },
  { source: MeasureUnitType.co, factor: 1, base: MeasureUnitType.co },
  { source: MeasureUnitType.qb, factor: 1, base: MeasureUnitType.qb },
];

export function getMeasureFactor(measureUnit: TMeasureUnitType) {
  return MeasureInfo.find(x => x.source === measureUnit)?.factor ?? 1;
}
